<div class='container' *ngIf="estimatedDuration">
    <app-confirmation
    [view]="view"
    [detailMap]="detailMap"
    [makeModelYear]="makeModelYear"
    [appointment]="appointment">
    </app-confirmation>
</div>
